module.exports = __webpack_public_path__ + "static/media/luxembourg.c858787c.svg";